export const PARTICLE_DIR = {
  TOP_RIGHT: 'topRight',
  TOP_LEFT: 'topLeft',
  BOTTOM_LEFT: 'bottomLeft',
  BOTTOM_RIGHT: 'bottomRight',
  BOTTOM: 'bottom',
  TOP: 'top',
  LEFT: 'left',
  RIGHT: 'right',
  NONE: 'none',
} as const;

export type PARTICLE_DIR_KEY = keyof typeof PARTICLE_DIR;
export type PARTICLE_DIR_VALUE = typeof PARTICLE_DIR[PARTICLE_DIR_KEY];

export const effectDirectionMap = [
  {
    key: PARTICLE_DIR.TOP_RIGHT,
    value: 'top-right',
  },
  {
    key: PARTICLE_DIR.TOP_LEFT,
    value: 'top-left',
  },
  {
    key: PARTICLE_DIR.BOTTOM_LEFT,
    value: 'bottom-left',
  },
  {
    key: PARTICLE_DIR.BOTTOM_RIGHT,
    value: 'bottom-right',
  },
  {
    key: PARTICLE_DIR.BOTTOM,
    value: 'bottom',
  },
  {
    key: PARTICLE_DIR.TOP,
    value: 'top',
  },
  {
    key: PARTICLE_DIR.LEFT,
    value: 'left',
  },
  {
    key: PARTICLE_DIR.RIGHT,
    value: 'right',
  },
  {
    key: PARTICLE_DIR.NONE,
    value: 'none',
  },
];
